module.exports = __webpack_public_path__ + "fonts/SalesforceSans-Italic.afa7774ce458bd2fc11c0f838f95a920.woff2";